import {ApplicationRef, Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, ViewContainerRef} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {LeadModalComponent} from '@app/product/lead/lead-modal/lead-modal.component';
import '@luigi-project/container';
import {ConfigService} from '@dcp/configurator';
import {LuigiContainer} from '@luigi-project/container';
import {LeadFormLuigiContext} from '@app/product/lead/lead.model';
import {LuigiLeadService} from '@app/product/lead/luigi-lead.service';

@Component({
  selector: 'dcp-lead-button',
  standalone: true,
  imports: [],
  templateUrl: './lead-button.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LeadButtonComponent implements OnInit {
  private static modalComponentRef: LeadModalComponent
  public url: string;

  public container: LuigiContainer;
  public context: LeadFormLuigiContext;

  constructor(
    private activatedRoute: ActivatedRoute,
    private leadService: LuigiLeadService,
    private applicationRef: ApplicationRef,
    private configService: ConfigService
  ) {
    this.url = this.configService.getString('webComponents.leadFormButton');
  }

  ngOnInit(): void {
    this.container = document.querySelector('#dcp-lead-form-button');

    this.context = this.leadService.setLuigiContextFromRoute(this.activatedRoute);

    if (LeadButtonComponent.modalComponentRef === undefined) {
      // Get the root view container ref of the application by injecting it into the root component
      const rootViewContainerRef = this.applicationRef.components[0].injector.get(ViewContainerRef);
      // Insert the modal component into the root view container
      const componentRef = rootViewContainerRef.createComponent(LeadModalComponent);
      // Get the instance of the modal component
      componentRef.instance.context = this.context;
      componentRef.changeDetectorRef.detectChanges();
      LeadButtonComponent.modalComponentRef = componentRef.instance;
    }
  }
}
